/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
var hidePriceUrls = [
    "/products/smart-camera-3d-with-io-link",
    "/products/smart-camera-3d-with-io-link-and-ethernet"
];

setInterval(function() {
    $('.boost-pfs-search-suggestion-item').each(function() {
        var productUrl = $(this).find('a').attr('href');
        
        // Check if productUrl contains any of the hidePriceUrls
        var shouldHidePrice = hidePriceUrls.some(function(hideUrl) {
            return productUrl.includes(hideUrl);
        });

        if (shouldHidePrice) {
            $(this).find('.boost-pfs-search-suggestion-product-price').hide();
        }
    });
}, 100);



  
  $('.productlist-media a').click(function(e){
    e.preventDefault();
  console.log();
    track_load($(this).attr('href'), $(this).parents('.prcol-wrap').find('.entry-title').text());
    var url = $(this).attr('href');
        window.open(url, '_blank');
});
  $('li[data-title="smart-double-sheet-sensors"]').click(function(e){
e.preventDefault();
    $(this).toggleClass('active');
   $(this).next('ul').toggle(); 
});
 $('.megamenuhead-a[data-title="rfid"]').click(function(e){
e.preventDefault();
    $(this).toggleClass('active');
   $('.submenu-ul-child[data-title="rfid"]').toggle(); 
});

  var outer_height1 = $(".pointmode_description.alarm_1_desc").height();
    $(".pointmode_description.alarm_2_desc").height(outer_height1);
      var outer_height2 = $(".detection_description.dual_output_desk1").outerHeight();
    $(".detection_description.dual_output_desk2").outerHeight(outer_height2);

    var outer_height = $(".timer-feature-wrapper div.pointmode_description").outerHeight();
    $("<style>")
        .prop("type", "text/css")
        .html(".timer-feature-wrapper .timer-inner-content .pointmode_image::after { height: " + outer_height + "px; }")
        .appendTo("head");

  
  // Contact Us Map JS START CODE
  $('body').on('click', '.subsidary_address_image', function(e) {
    e.preventDefault;
var data_sub= $(this).attr("data-block-id");
      $(".custom_map_details .custom_contact_address").hide();
   $(".custom_map_details .custom_contact_address[data-block-id='"+data_sub+"']").show();
  $(".custom_map_details .custom_contact_address[data-block-id='"+data_sub+"']").show();
   
});
 // Contact Us Map JS END CODE
  
  //   $('.first_selectbox_option_chnage_1 option').removeClass('noavailable_variant');
  $('.product-variant-option-no-2 .block-swatch').removeClass('noavailable_variant');
  $('.product-variant-option-no-3 .block-swatch').removeClass('noavailable_variant');

  $('.product-variant-option-no-2 .block-swatch').removeClass('availablelist_variant');
  $('.product-variant-option-no-3 .block-swatch').removeClass('availablelist_variant');
  
  var first_val =  $('.product-variant-option-no-1').find('input:checked').val();
  var thired_val = '';
  if ($('.product-variant-option-no-1').parents('.product-form__variants').find('.block-swatch-list').hasClass("product-variant-option-no-3")) {
    thired_val = $('.product-variant-option-no-3').find('input:checked').val();   
  }
  jsonoption = {};

  $('.hide-selectbox-option option').each(function(){
    var name =  $(this).data('name');
    var available =  $(this).data('availabe');
    jsonoption[name] = available;
  });

  if ($('.product-variant-option-no-1').parents('.product-form__variants').find('.block-swatch-list').hasClass("product-variant-option-no-2")) {
    $('.product-variant-option-no-2 .block-swatch').each(function(index){
      var second_val = $(this).find('input').val();
      if(thired_val != ''){
        var variant_combination = [];
        $('.product-variant-option-no-3 .block-swatch').each(function(index){
          var thired_val = $(this).find('input').val();
          var created_option = first_val + ' / ' + second_val + ' / ' + thired_val;
          var getoption_array = jsonoption[created_option];
          if(getoption_array != undefined){
            variant_combination.push(created_option); 
          }
        });
        if (variant_combination.length == 0){
          $(this).addClass('noavailable_variant');
        }else{
          $(this).addClass('availablelist_variant');
        }
      }else{
        var created_option = first_val + ' / ' + second_val;
        var getoption_array = jsonoption[created_option];
        if(getoption_array == undefined){
          $(this).addClass('noavailable_variant');
        }else{
          $(this).addClass('availablelist_variant');
        }
      }

    });
  }

  var second_val1 = $('.product-variant-option-no-2').find('input:checked').val(); 
  if ($('.product-variant-option-no-1').parents('.product-form__variants').find('.block-swatch-list').hasClass("product-variant-option-no-3")) {
    $('.product-variant-option-no-3 .block-swatch').each(function(index){
      var thired_val1 = $(this).find('input').val();
      var created_option = first_val + ' / ' + second_val1 + ' / ' + thired_val1;
      var getoption_array = jsonoption[created_option];
      if(getoption_array == undefined){
        $(this).addClass('noavailable_variant');
      }else{
        $(this).addClass('availablelist_variant');
      }
    });
  }

  if($('.product-variant-option-no-2 input:checked').parents('.block-swatch').hasClass('noavailable_variant')){
    $(".product-variant-option-no-2 .availablelist_variant:eq(0)").find('.block-swatch__item').trigger('click');
  }


  if($('.product-variant-option-no-3 input:checked').parents('.block-swatch').hasClass('noavailable_variant')){
    $(".product-variant-option-no-3 .availablelist_variant:eq(0)").find('.block-swatch__item').trigger('click');
  }
});






// product page variant meta fild change on change variant Start (RB)
$('.block-swatch__item').click(function(){
  setTimeout(function(){
    var url = $('.hide-selectbox-option').children("option:selected").attr('data-url');
    $.ajax({
      url: url,
      success: function(result){
        var data = $(result).find('.variant-metafileds-value-holder').html();
 
        $(".variant-metafileds-value-holder").html(data);
        var data_2 = $(result).find('.3d-cdavar').html();
        $(".3d-cdavar").html(data_2);
    $(".sku_description").html($('.sku_description',result).html()).show();
      }
    });
  }, 500);
});

// on variant click (Click on first variant):: Start
$(document).on('click','.product-variant-option-no-1 .block-swatch', function(){
  
  //   remove Class 2 and 3 option on all variant 
  $('.product-variant-option-no-2 .block-swatch').removeClass('noavailable_variant');
  $('.product-variant-option-no-3 .block-swatch').removeClass('noavailable_variant');
  $('.product-variant-option-no-2 .block-swatch').removeClass('availablelist_variant');
  $('.product-variant-option-no-3 .block-swatch').removeClass('availablelist_variant');
  //   get first variant click option value
  var first_val = $(this).find('input').val();
  //   get third variant selected value
  var thired_val = '';
  if ($(this).parents('.product-form__variants').find('.block-swatch-list').hasClass("product-variant-option-no-3")) {
    thired_val = $('.product-variant-option-no-3').find('input:checked').val();   
  }
  //   gat all variant json
  jsonoption = {};
  $('.hide-selectbox-option option').each(function(){
    var name =  $(this).data('name');
    var available =  $(this).data('availabe');
    jsonoption[name] = available;
  });
  //   check if second variant 
  if ($(this).parents('.product-form__variants').find('.block-swatch-list').hasClass("product-variant-option-no-2")) {
    $('.product-variant-option-no-2 .block-swatch').each(function(index){
      var second_val = $(this).find('input').val();
      if(thired_val != ''){
        var variant_combination = [];
        $('.product-variant-option-no-3 .block-swatch').each(function(index){
          var thired_val = $(this).find('input').val();
          var created_option = first_val + ' / ' + second_val + ' / ' + thired_val;
          var getoption_array = jsonoption[created_option];
          if(getoption_array != undefined){
            variant_combination.push(created_option); 
          }
        });
        if (variant_combination.length == 0){
          $(this).addClass('noavailable_variant');
        }else{
          $(this).addClass('availablelist_variant');
        }
      }else{
        var created_option = first_val + ' / ' + second_val;
        var getoption_array = jsonoption[created_option];
        if(getoption_array == undefined){
          $(this).addClass('noavailable_variant');
        }else{
          $(this).addClass('availablelist_variant');
        }
      }

    });
  }
  //   get second variant selected value 
  var second_val1 = $('.product-variant-option-no-2').find('input:checked').val(); 
  //   check if third variant 
  if ($(this).parents('.product-form__variants').find('.block-swatch-list').hasClass("product-variant-option-no-3")) {
    $('.product-variant-option-no-3 .block-swatch').each(function(index){
      var thired_val1 = $(this).find('input').val();
      var created_option = first_val + ' / ' + second_val1 + ' / ' + thired_val1;
      var getoption_array = jsonoption[created_option];
      if(getoption_array == undefined){
        $(this).addClass('noavailable_variant');
      }else{
        $(this).addClass('availablelist_variant');
      }
    });
  }
  if($('.product-variant-option-no-2 input:checked').parents('.block-swatch').hasClass('noavailable_variant')){
   $(".product-variant-option-no-2 .availablelist_variant:eq(0)").find('.block-swatch__item').trigger('click');
  }
  if($('.product-variant-option-no-3 input:checked').parents('.block-swatch').hasClass('noavailable_variant')){
    $(".product-variant-option-no-3 .availablelist_variant:eq(0)").find('.block-swatch__item').trigger('click');
  }
});
// on variant click (Click on first variant)::End
// on variant click (Click on Second variant):: Start
$(document).on('click','.product-variant-option-no-2 .block-swatch', function(){
  //   remove Class 2 and 3 option on all variant 
  $('.product-variant-option-no-3 .block-swatch').removeClass('noavailable_variant');

  $('.product-variant-option-no-3 .block-swatch').removeClass('availablelist_variant');
  //   get first variant click option value
  var second_val = $(this).find('input').val();
  //   gat all variant json
  jsonoption = {};

  $('.hide-selectbox-option option').each(function(){
    var name =  $(this).data('name');
    var available =  $(this).data('availabe');
    jsonoption[name] = available;
  });
  //   get first variant selected value 
  var first_val = $('.product-variant-option-no-1').find('input:checked').val(); 

  //   check if third variant 

  if ($(this).parents('.product-form__variants').find('.block-swatch-list').hasClass("product-variant-option-no-3")) {
    $('.product-variant-option-no-3 .block-swatch').each(function(index){
      var thired_val1 = $(this).find('input').val();
      var created_option = first_val + ' / ' + second_val + ' / ' + thired_val1;
      var getoption_array = jsonoption[created_option];
      if(getoption_array == undefined){
        $(this).addClass('noavailable_variant');
      }else{
        $(this).addClass('availablelist_variant');
      }
    });
  }
  if($('.product-variant-option-no-3 input:checked').parents('.block-swatch').hasClass('noavailable_variant')){
    $(".product-variant-option-no-3 .availablelist_variant:eq(0)").find('.block-swatch__item').trigger('click');
  }

});

$('body').on('click','.first_stage h4',function(){
    $(this).closest('li').find('.first-lavel').toggle('');
  });
   $('body').on('click','.second-stage',function(){
    $(this).find('.second-lavel').toggle('');
  });
  $('body').on('click','.third-stage',function(){
    $(this).find('.third-lavel').toggle('');
  });
    $("select.data_lang_select").change(function(){
      var lang = $(this).children("option:selected").val();
      var hf = $(this).next('.data_lang_main').find('.data_lang_'+lang).attr('href');
      
      if(hf != undefined){
        $(this).parent('.project-list-content').siblings('.productlist-media').children('a').attr("href", hf);
      }else{
        $(this).parent('.project-list-content').siblings('.productlist-media').children('a').attr("href", '#');
      }
      
    });

  /******* Blog page Load more Button Click ********/
function blogmore() {
    let moreButon = $('#more').last();
    var nextUrl =  $('#more').attr("href");
    // Make ajax call to next page for load more data
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType:'html',
      beforeSend: function() {
        moreButon.remove();
      }
    })
    .done(function(data) {
      // alert($(data).find('.block-list'));
      $('.blog-articles__article .block-list').append($(data).find('.block-list').html());
    });
}
  /******* Blog page Load more Button Click ********/
  /******* Blog page Load more Button auto click on scroll ********/
  if(window.location.href.indexOf('/blogs') > -1 && $('.page-width a#more').length > 0){
    $(document).on('scroll', function() {
      if($(window).scrollTop() <= $('.page-width a#more').position().top ){
      blogmore();
        $("#product-list-foot").show();
      }
      else{
        $("#product-list-foot").hide();
      }
    });
  }
$(document).on("click",".header__cart-toggle",function() {
    $("body").removeClass("boost-sd__modal-open");
    $(".boost-sd__modal").remove();
});
$(document).on('click',".product-item__action-button",function() {
    setTimeout(function() {
    $(".modal[aria-hidden=false] .block-swatch-list.product-variant-option-no-1 .block-swatch").eq(0).trigger("click");     
    },1200);
   
});
